export default "/images/vendor/flag-icon-css/flags/4x3/mh.svg?c0b2e372c1a8cb36930ed13adc05d0a8";